import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { ThemeOptions, ThemeOverride, } from '@wix/da-react-context/pkg/ThemeContext';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import s from './MonetizationPromoStrip.scss';
export var MonetizationPromoStrip = function (_a) {
    var monetizationPromo = _a.monetizationPromo, className = _a.className;
    var t = useTranslation().t;
    if (!['tier', 'commission'].includes(monetizationPromo)) {
        return null;
    }
    return (React.createElement(ThemeOverride, { theme: ThemeOptions.DARK },
        React.createElement("div", { className: classnames(s['root'], className) },
            React.createElement(PromoBadge, { badgeType: monetizationPromo, size: 24, className: s['badge'] }),
            React.createElement("div", { className: s['text'] }, t("avatar.monetizationPromoStrip.var.".concat(monetizationPromo, ".body"))))));
};
MonetizationPromoStrip.displayName = 'MonetizationPromoStrip';
export default MonetizationPromoStrip;
//# sourceMappingURL=MonetizationPromoStrip.js.map